import { Button, Card, Flex, Spin, Steps, Typography } from "antd";
import { useForm, useWatch } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../treasury.config";
import Accounting from "./components/add/AccountingForm";
import BondFeaturesForm from "./components/add/BondFeaturesForm";
import InterestSettings from "./components/add/InterestSettingsForm";
import IssuerDetails from "./components/add/IssuerDetailsForm";
import Preview from "./components/add/Preview";
import ProductInformationForm from "./components/add/ProductInformationForm";
import TaxAndCharges from "./components/add/TaxAndChargesForm";
import FeedbackModal from "./components/FeedbackModal";
import { getCurrencySymbol } from "../../../components/facilities/TreasuryFacility";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
// import "../../../assets/styles/InterbankPlacement.css";

const { Text } = Typography;

const AddNewBond = (props) => {
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = useForm();
  const couponRate = useWatch("couponRate", form);

  const [current, setCurrent] = useState(0);
  const [floatingSearchInput, setFloatingSearchInput] = useState("");
  const [checkedCallable, setCheckedCallable] = useState(false);
  const [checkedPutable, setCheckedPutable] = useState(false);
  const [checkedConvertible, setCheckedConvertible] = useState(false);
  const [checkedSetup, setCheckedSetup] = useState(false);
  const [checkedRedemption, setCheckedRedemption] = useState(false);
  const [checkedTransfer, setCheckedTransfer] = useState(false);
  const [checkedBrokerage, setCheckedBrokerage] = useState(false);
  const [checkedTaxGroup, setCheckedTaxGroup] = useState(false);
  const [checkedRepaymentType, setCheckedRepaymentType] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currency, setCurrency] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [bondProductDetails, setBondProductDetails] = useState([]);
  const [isStepDisabled, setIsStepDisabled] = useState(true);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [issueTypeOptions, setIssueTypeOptions] = useState([]);
  const [bondTypeOptions, setBondTypeOptions] = useState([]);
  const [issuerNameOptions, setIssuerNameOptions] = useState([]);
  const [custodianOptions, setCustodianOptions] = useState([]);
  const [
    accountingClassificationsOptions,
    setAccountingClassificationsOptions,
  ] = useState([]);
  const [issuerTypeOptions, setIssuerTypeOptions] = useState([]);
  const [creditRatingOptions, setCreditRatingOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [issuePriceOptions, setIssuePriceOptions] = useState([]);
  const [couponRateOptions, setCouponRateOptions] = useState([]);
  const [floatingRateOptions, setFloatingRateOptions] = useState([]);
  const [couponFrequencyOptions, setCouponFrequencyOptions] = useState([]);
  const [firstCouponDate, setFirstCouponDate] = useState([]);
  const [maturityDateOptions, setMaturityDateOptions] = useState([]);
  const [ammortizationOptions, setAmmortizationOptions] = useState([]);
  const [interestCalculationBasisOptions, setInterestCalculationBasisOptions] =
    useState([]);
  const [interestStartDateOptions, setInterestStartDateOptions] = useState([]);
  const [interestPaymentModeOptions, setInterestPaymentModeOptions] = useState(
    []
  );
  const [chargeOptions, setChargeOptions] = useState([]);
  const [taxGroupOptions, setTaxGroupOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [formData, setFormData] = useState({
    productInformation: null,
    issuerDetails: null,
    bondFeatures: {
      callable: false,
      putable: false,
      convertible: false,
    },
    interestSettings: null,
    taxAndCharges: {
      brokerage: {
        enabled: false,
      },
      setup: {
        enabled: false,
      },
      redemption: {
        enabled: false,
      },
      transfer: {
        enabled: false,
      },
    },
    accounting: null,
  });

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.BondProductTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;

        setBondProductDetails(objList);

        let tempProductCategory = [];
        let tempCurrency = [];
        let tempIssueType = [];
        let tempBondType = [];
        let tempIssuerName = [];
        let tempCustodians = [];
        let tempAccountingClassifications = [];
        let tempIssuerType = [];
        let tempCreditRating = [];
        let tempCountries = [];
        let tempIssuePrice = [];
        let tempCouponRate = [];
        let tempCouponFrequency = [];
        let tempMaturityDate = [];
        let tempAmmortization = [];
        let tempInterestCalculationBasis = [];
        let tempInterestStartDate = [];
        let tempFirstCouponDate = [];
        let tempInterestPaymentMode = [];
        let tempCharges = [];
        let tempTaxGroups = [];
        let tempAssetGlAccounts = [];
        let tempIncomeGlAccounts = [];

        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
            symbol: element.displaySymbol,
          });
        });

        objList?.countries?.forEach((element) => {
          tempCountries.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.bondTypes?.forEach((element) => {
          tempBondType.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondProductCategories?.forEach((element) => {
          tempProductCategory.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondIssueTypes?.forEach((element) => {
          tempIssueType.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.issuers?.forEach((element) => {
          tempIssuerName.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.custodians?.forEach((element) => {
          tempCustodians.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.accountingClassifications?.forEach((element) => {
          tempAccountingClassifications.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.issuerTypes?.forEach((element) => {
          tempIssuerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.creditRatings?.forEach((element) => {
          tempCreditRating.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondIssuePrices?.forEach((element) => {
          tempIssuePrice.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponRates?.forEach((element) => {
          tempCouponRate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempCouponFrequency.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.maturityProceeds?.forEach((element) => {
          tempMaturityDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondAmortizations?.forEach((element) => {
          tempAmmortization.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.interestCalculationBasisOptions?.forEach((element) => {
          tempInterestCalculationBasis.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.interestStartDates?.forEach((element) => {
          tempInterestStartDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempFirstCouponDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondInterestPaymentModes?.forEach((element) => {
          tempInterestPaymentMode.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempCharges.push({
            value: element.id,
            label: element.name,
            active: element?.active,
            chargeTimeType: element?.chargeTimeType?.value,
            chargeAppliesTo: element?.chargeAppliesTo?.value,
          });
        });

        objList?.taxGroupOptions?.forEach((element) => {
          tempTaxGroups.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.assetGLAccounts?.forEach((element) => {
          tempAssetGlAccounts.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currency: element.currencyCode,
          });
        });

        objList?.incomeGlAccounts?.forEach((element) => {
          tempIncomeGlAccounts.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currency: element.currencyCode,
          });
        });

        setProductCategoryOptions(tempProductCategory);
        setCurrencyOptions(tempCurrency);
        setIssueTypeOptions(tempIssueType);

        const defaultIssueType = tempIssueType.find(
          (option) => option.label.toLowerCase() === "auction"
        );
        if (defaultIssueType) {
          form.setFieldsValue({ issueType: defaultIssueType.value });
        }

        setBondTypeOptions(tempBondType);

        const defaultBondType = tempBondType.find(
          (option) => option.label.toLowerCase() === "fixed rate"
        );
        if (defaultBondType) {
          form.setFieldsValue({ bondType: defaultBondType.value });
        }

        setIssuerNameOptions(tempIssuerName);
        setCustodianOptions(tempCustodians);
        setAccountingClassificationsOptions(tempAccountingClassifications);
        setIssuerTypeOptions(tempIssuerType);
        setCreditRatingOptions(tempCreditRating);
        setCountriesOptions(tempCountries);

        const defaultCountry = tempCountries.find(
          (option) => option.label.toLowerCase() === "nigeria"
        );
        if (defaultCountry) {
          form.setFieldsValue({ country: defaultCountry.value });
        }

        setIssuePriceOptions(tempIssuePrice);

        const defaultIssuePrice = tempIssuePrice.find(
          (option) => option.label.toLowerCase() === "discount"
        );
        if (defaultIssuePrice) {
          form.setFieldsValue({ issuePrice: defaultIssuePrice.value });
        }

        setCouponRateOptions(tempCouponRate);

        const defaultCouponRate = tempCouponRate.find(
          (option) => option.label.toLowerCase() === "fixed"
        );
        if (defaultCouponRate) {
          form.setFieldsValue({ couponRate: defaultCouponRate.value });
        }

        setCouponFrequencyOptions(tempCouponFrequency);
        setMaturityDateOptions(tempMaturityDate);
        setAmmortizationOptions(tempAmmortization);
        setInterestCalculationBasisOptions(tempInterestCalculationBasis);

        const defaultInterestCalculationBasis =
          tempInterestCalculationBasis.find(
            (option) =>
              option.label.toLowerCase() === "30/360 (standard bond markets)"
          );
        if (defaultInterestCalculationBasis) {
          form.setFieldsValue({
            interestCalculationBasis: defaultInterestCalculationBasis.value,
          });
        }

        // const tempProcessingCharge = tempWitholdingTax;

        setInterestStartDateOptions(tempInterestStartDate);
        setFirstCouponDate(tempFirstCouponDate);
        setInterestPaymentModeOptions(tempInterestPaymentMode);
        setChargeOptions(tempCharges);
        setTaxGroupOptions(tempTaxGroups);
        setAssetAccountOptions(tempAssetGlAccounts);
        setIncomeAccountOptions(tempIncomeGlAccounts);
        setIsLoading(false);
      }
    });
  }

  const getFloatingRate = (searchText) => {
    const url = `${apiConfig.SearchFloatingRates}${searchText}`;

    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
        return;
      }

      const objList = res;

      const tempArray = objList.map((element) => ({
        value: element?.id,
        label: element?.name,
      }));

      setFloatingRateOptions(tempArray);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (!floatingSearchInput) return;

    const timeout = setTimeout(() => {
      getFloatingRate(floatingSearchInput);
    }, 500);

    return () => clearTimeout(timeout);
  }, [floatingSearchInput]);

  const filteredAssetAccounts = assetAccountOptions.filter(
    (item) => item.currency === currency
  );

  const filteredIncomeAccounts = incomeAccountOptions.filter(
    (item) => item.currency === currency
  );

  const handleClose = () => {
    setSuccessModalVisible(false);
    setWarningModalVisible(false);
  };

  const stepTitles = [
    "Product Information",
    "Issuer Details",
    "Bond Features",
    "Interest Settings",
    "Tax & Charges",
    "Accounting",
    "Preview",
  ];

  const onChange = (value) => {
    setCurrent(value);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/bond-product", { replace: false });
  }

  const onFinishProductInformationForm = (values) => {
    values.startDate = values.startDate
      ? BOM.DateTime(values.startDate, "only-date")
      : values.startDate;
    values.endDate = values.endDate
      ? BOM.DateTime(values.endDate, "only-date")
      : values.endDate;

    const selectFields = [
      { key: "productCategory", options: productCategoryOptions },
      { key: "currency", options: currencyOptions },
      { key: "issueType", options: issueTypeOptions },
      { key: "bondType", options: bondTypeOptions },
      { key: "custodian", options: custodianOptions },
      {
        key: "accountingClassification",
        options: accountingClassificationsOptions,
      },
    ];

    const enrichedValues = { ...values };

    selectFields.forEach(({ key, options }) => {
      const selected = options.find((opt) => opt.value === values[key]);
      enrichedValues[`${key}Label`] = selected?.label || values[key];
    });

    setFormData({
      ...formData,
      productInformation: enrichedValues,
    });

    setCurrent(current + 1);
  };

  const onFinishIssuerDetailsForm = (values) => {
    const selectFields = [
      { key: "issuerType", options: issuerTypeOptions },
      { key: "country", options: countriesOptions },
    ];

    const enrichedValues = { ...values };

    selectFields.forEach(({ key, options }) => {
      const selected = options.find((opt) => opt.value === values[key]);
      enrichedValues[`${key}Label`] = selected?.label || values[key];
    });

    setFormData({ ...formData, issuerDetails: enrichedValues });

    setCurrent(current + 1);
  };

  const onFinishBondFeaturesForm = (values) => {
    values.callable = checkedCallable;
    values.putable = checkedPutable;
    values.convertible = checkedConvertible;
    values.repayment = checkedRepaymentType;

    values.maturityDate = values.maturityDate
      ? BOM.DateTime(values.maturityDate, "only-date")
      : values.maturityDate;

    const selectFields = [
      { key: "issuePrice", options: issuePriceOptions },
      { key: "couponRate", options: couponRateOptions },
      { key: "couponFrequency", options: couponFrequencyOptions },
      { key: "maturityDate", options: maturityDateOptions },
      { key: "repaymentType", options: ammortizationOptions },
    ];

    const enrichedValues = { ...values };

    selectFields.forEach(({ key, options }) => {
      const selected = options.find((opt) => opt.value === values[key]);
      enrichedValues[`${key}Label`] = selected?.label || values[key];
    });

    setFormData({ ...formData, bondFeatures: enrichedValues });
    setCurrent(current + 1);
  };

  const onFinishInterestSettingsForm = (values) => {
    const selectFields = [
      {
        key: "interestCalculationBasis",
        options: interestCalculationBasisOptions,
      },
      { key: "interestStartDate", options: interestStartDateOptions },
      { key: "firstCouponDate", options: firstCouponDate },
      { key: "interestPaymentMode", options: interestPaymentModeOptions },
    ];

    const enrichedValues = { ...values };

    selectFields.forEach(({ key, options }) => {
      const selected = options.find((opt) => opt.value === values[key]);
      enrichedValues[`${key}Label`] = selected?.label || values[key];
    });

    setFormData({ ...formData, interestSettings: enrichedValues });
    setCurrent(current + 1);
  };

  const onFinishTaxAndChargesForm = (values) => {
    const getTaxLabel = (chargeValue) =>
      taxGroupOptions.find((opt) => opt.value === chargeValue)?.label;
    const getLabel = (chargeValue) =>
      chargeOptions.find((opt) => opt.value === chargeValue)?.label;

    values.brokerage = {
      enabled: checkedBrokerage,
      commission: values.commission,
      commissionLabel: getLabel(values.commission),
    };

    values.taxGroup = {
      enabled: checkedTaxGroup,
      tax: values.taxGroup,
      taxLabel: getTaxLabel(values.taxGroup),
    };

    values.setup = {
      enabled: checkedSetup,
      charges: values.setupCharges,
      chargeLabel: getLabel(values.setupCharges),
    };

    values.redemption = {
      enabled: checkedRedemption,
      charges: values.redemptionCharges,
      chargeLabel: getLabel(values.redemptionCharges),
    };

    values.transfer = {
      enabled: checkedTransfer,
      charges: values.transferCharges,
      chargeLabel: getLabel(values.transferCharges),
    };

    // delete values.commission;
    // delete values.charges;
    // delete values.setupCharges;
    // delete values.redemptionCharges;
    // delete values.transferCharges;

    setFormData({ ...formData, taxAndCharges: values });
    setCurrent(current + 1);
  };

  const onFinishAccountingForm = (values) => {
    const selectFields = [
      { path: "investmentGL", index: 0, options: assetAccountOptions },
      { path: "investmentGL", index: 1, options: assetAccountOptions },
      { path: "accruedInterestGL", index: 0, options: assetAccountOptions },
      { path: "accruedInterestGL", index: 1, options: assetAccountOptions },
      { path: "settlementGL", index: 0, options: assetAccountOptions },
      { path: "settlementGL", index: 1, options: assetAccountOptions },
      { path: "interestIncomeGL", index: 0, options: incomeAccountOptions },
      { path: "interestIncomeGL", index: 1, options: incomeAccountOptions },
      { path: "feeGL", index: 0, options: incomeAccountOptions },
      { path: "feeGL", index: 1, options: incomeAccountOptions },
      { path: "penaltyGL", index: 0, options: incomeAccountOptions },
      { path: "penaltyGL", index: 1, options: incomeAccountOptions },
    ];
    const enrichedValues = { ...values };

    selectFields.forEach(({ path, index, options }) => {
      const selectedValue = values[path]?.[index];
      const selectedOption = options.find((opt) => opt.value === selectedValue);
      if (selectedOption) {
        if (!enrichedValues[`${path}Label`]) {
          enrichedValues[`${path}Label`] = [];
        }
        enrichedValues[`${path}Label`][index] = selectedOption.label;
      }
    });

    setFormData({ ...formData, accounting: enrichedValues });
    setCurrent(current + 1);
  };

  const handleCurrencyChange = (currencyCode) => {
    setCurrency(currencyCode);
    const symbol = getCurrencySymbol(currencyCode, currencyOptions);
    setCurrencySymbol(symbol);
  };

  const forms = [
    <ProductInformationForm
      onFinish={onFinishProductInformationForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={{
        currency: "NGN",
        ...formData.productInformation,
      }}
      productCategoryOptions={productCategoryOptions}
      currencyOptions={currencyOptions}
      issueTypeOptions={issueTypeOptions}
      bondTypeOptions={bondTypeOptions}
      custodianOptions={custodianOptions}
      accountingClassificationsOptions={accountingClassificationsOptions}
      onCurrencyChange={handleCurrencyChange}
      form={form}
    />,
    <IssuerDetails
      onFinish={onFinishIssuerDetailsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.issuerDetails}
      issuerNameOptions={issuerNameOptions}
      issuerTypeOptions={issuerTypeOptions}
      creditRatingOptions={creditRatingOptions}
      countriesOptions={countriesOptions}
      form={form}
    />,
    <BondFeaturesForm
      onFinish={onFinishBondFeaturesForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.bondFeatures}
      form={form}
      couponRate={couponRate}
      currencySymbol={currencySymbol}
      issuePriceOptions={issuePriceOptions}
      couponRateOptions={couponRateOptions}
      floatingRateOptions={floatingRateOptions}
      couponFrequencyOptions={couponFrequencyOptions}
      maturityDateOptions={maturityDateOptions}
      ammortizationOptions={ammortizationOptions}
      checkedCallable={checkedCallable}
      checkedPutable={checkedPutable}
      checkedRepaymentType={checkedRepaymentType}
      checkedConvertible={checkedConvertible}
      setCheckedCallable={setCheckedCallable}
      setCheckedPutable={setCheckedPutable}
      setCheckedConvertible={setCheckedConvertible}
      setCheckedRepaymentType={setCheckedRepaymentType}
      setFloatingSearchInput={setFloatingSearchInput}
    />,
    <InterestSettings
      onFinish={onFinishInterestSettingsForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.interestSettings}
      interestCalculationBasisOptions={interestCalculationBasisOptions}
      interestStartDateOptions={interestStartDateOptions}
      firstCouponDate={firstCouponDate}
      interestPaymentModeOptions={interestPaymentModeOptions}
      form={form}
    />,
    <TaxAndCharges
      onFinish={onFinishTaxAndChargesForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.taxAndCharges}
      form={form}
      chargeOptions={chargeOptions}
      taxGroupOptions={taxGroupOptions}
      checkedSetup={checkedSetup}
      checkedRedemption={checkedRedemption}
      checkedTransfer={checkedTransfer}
      checkedBrokerage={checkedBrokerage}
      checkedTaxGroup={checkedTaxGroup}
      setCheckedSetup={setCheckedSetup}
      setCheckedRedemption={setCheckedRedemption}
      setCheckedTransfer={setCheckedTransfer}
      setCheckedBrokerage={setCheckedBrokerage}
      setCheckedTaxGroup={setCheckedTaxGroup}
    />,
    <Accounting
      onFinish={onFinishAccountingForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.accounting}
      assetAccountOptions={filteredAssetAccounts}
      incomeAccountOptions={filteredIncomeAccounts}
      form={form}
    />,
    <Preview formData={formData} currencySymbol={currencySymbol} />,
  ];

  const isLastStep = current === forms.length - 1;

  const onSubmit = () => {
    let formValues = {
      ...formData.productInformation,
      ...formData.issuerDetails,
      ...formData.interestSettings,
      ...formData.accounting,
      ...formData.bondFeatures,
    };

    formValues.currencyCode = formValues?.currency;
    formValues.bondIssueType = formValues?.issueType;
    formValues.bondProductCategory = formValues?.productCategory;
    formValues.bondIssuePrice = formValues?.issuePrice;
    formValues.bondInterestPaymentMode = formValues?.interestPaymentMode;
    formValues.bondCouponRate = formValues?.couponRate;
    formValues.bondCouponFrequency = formValues?.couponFrequency;
    formValues.bondAmortization = formValues?.amortization;
    formValues.bondIssuerName = formValues?.issuerName;
    formValues.puttable = formValues?.putable;
    formValues.convertibleToEquity = formValues?.convertible;
    formValues.allowRepaymentType = formValues?.repayment;
    formValues.bondAmortization = formValues?.repaymentType;
    // formValues.allowWithholdingTax =
    //   formData?.taxAndCharges?.witholding?.enabled;
    // formValues.withholdingTax = formData?.taxAndCharges?.witholding?.charges;
    formValues.commission = formData?.taxAndCharges?.brokerage?.commission;
    formValues.setupCharges = formData?.taxAndCharges?.setup?.enabled;
    formValues.setupCharge = formData?.taxAndCharges?.setup?.charges;
    formValues.redemptionCharges = formData?.taxAndCharges?.redemption?.enabled;
    formValues.redemptionCharge = formData?.taxAndCharges?.redemption?.charges;
    formValues.transferCharges = formData?.taxAndCharges?.transfer?.enabled;
    formValues.transferCharge = formData?.taxAndCharges?.transfer?.charges;
    formValues.allowBrokerage = formData?.taxAndCharges?.brokerage?.enabled;
    formValues.allowTax = formData?.taxAndCharges?.taxGroup?.enabled;
    formValues.taxGroup = formData?.taxAndCharges?.taxGroup?.tax;
    formValues.bondTenor = parseFloat(formValues?.tenor);
    formValues.charges = parseFloat(
      formData?.taxAndCharges?.witholding?.charges
    );

    delete formValues.productCategory;
    delete formValues.currency;
    delete formValues.issueType;
    delete formValues.issuePrice;
    delete formValues.interestPaymentMode;
    delete formValues.couponRate;
    delete formValues.couponFrequency;
    delete formValues.issuerName;
    delete formValues.putable;
    delete formValues.convertible;
    delete formValues.repayment; // remove after fix
    delete formValues.repaymentType; // remove after fix
    delete formValues.charges; // remove after fix
    delete formValues.tenor;

    formValues = Object.fromEntries(
      Object.entries(formValues).filter(([key]) => !key.endsWith("Label"))
    );

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.AddBondProduct,
      (err, res) => {
        if (err) {
          let message =
            err.errors?.[0]?.defaultUserMessage || "An error occurred";

          // Format specific message
          if (
            message === "A product with the same productCode already exists."
          ) {
            message = "A product with the same product code already exists.";
          }

          BOM.AlertMsg(cnt.DANGER, message);
          setIsLoading(false);
        } else {
          setSuccessModalVisible(true);
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          setIsLoading(false);
          navigate("/bond-product");
        },
      }
    );
  };

  return (
    <MainLayout pageItems={staticConfig.newBondItems} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.createBondTitle}
        createPageTitle={labelConfig.createBond}
      />
      <Spin spinning={isLoading} size="large">
        <div
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            widtth: "100%",
          }}
        >
          {/* Navigation section */}
          <div style={{ width: "288px", padding: "20px 0" }}>
            <Steps
              className="custom-step-style"
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "723px" }}
              items={[
                {
                  title: <Text strong>Product Information</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Issuer Details</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Bond Features</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Interest Settings</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Tax & Charges</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Accounting</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Preview</Text>,
                  disabled: isStepDisabled,
                },
              ]}
            />
          </div>

          {/* Form section */}
          <Card
            style={{
              borderRadius: 20,
              width: "100%",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              padding: "0 20px",
              height: `${current === forms.length - 1 ? "723px" : "100%"}`,
              overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
            }}
          >
            <div style={{ flexGrow: 1 }}>{forms[current]}</div>

            {/* Button Section (at bottom) */}
            <div
              style={{
                paddingTop: 30,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="30px" align="end">
                {current === 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={() => setWarningModalVisible(true)}
                  >
                    Go Back
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next - {stepTitles[current + 1]}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_BOND") && isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={onSubmit}
                  >
                    Create Product
                  </Button>
                )}
              </Flex>
            </div>
          </Card>
        </div>
      </Spin>

      {/* Success Modal */}
      <FeedbackModal
        visible={successModalVisible}
        type="success"
        onPrimaryAction={handleClose}
        onSecondaryAction={() => {
          onCancel();
        }}
        onClose={handleClose}
        message="Bond product has been successfully created."
      />

      {/* Warning Modal */}
      <FeedbackModal
        visible={warningModalVisible}
        type="warning"
        onPrimaryAction={() => {
          onCancel();
        }}
        onSecondaryAction={() => {
          handleClose();
        }}
        onClose={handleClose}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewBond);
